var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadIndicatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10800_33104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9906 1.69617C13.824 4.12358 12.7401 6.39667 10.959 8.05423C9.17776 9.71179 6.83266 10.6296 4.39955 10.6215C4.23748 10.6215 3.84965 10.6297 3.68799 10.6215H1.03645",
    stroke: "#A1A5AC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2041 7.43042L1.0094 10.6251L4.2041 13.8198",
    stroke: "#A1A5AC",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10800_33104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadIndicatorIcon);
export default __webpack_public_path__ + "static/media/threadIndicatorIcon.1d6edb19556b61c8c13bb61004bf2745.svg";
export { ForwardRef as ReactComponent };